var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChoice',{attrs:{"title":"関連付けるコースを選択してください","resourceType":"course","fields":_vm.fields,"items":_vm.course.courses,"totalItems":_vm.totalCourses,"isFetching":_vm.isFetching}})}
var staticRenderFns = []

export { render, staticRenderFns }